import { Injectable } from '@angular/core';
import { AlertService } from '@core/services/alert/alert.service';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { NewAccountService } from '@core/services/new-products/new-account.service';
import { IProductCommandContext } from '@shared/models/command';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class SaleMetalCommand extends BaseProductCommand {
  readonly type = 'sale';
  readonly title = 'Продать';
  readonly icon = 'forward';
  readonly productType = ProductTypes.METAL_ACCOUNT;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 3; // Третий в actions для metallAccount

  constructor(
    private navigationService: NavigationService,
    private alertService: AlertService,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    if (NewAccountService.excludedAccountCurrencies.includes(context.data.currencyCode)) {
      this.alertService.showInfoAlert('Для проведения операции обратитесь в офис Банка');
    } else {
      this.navigationService.push('/payments/transfer/self', {
        queryParams: {
          accId: context.data.id,
          operationType: 'saleMetal'
        }
      });
    }
  }
}

